function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.081v11.654C0 18.435.566 19 1.263 19H13.89c.698 0 1.262-.566 1.262-1.265v-2.74a.778.778 0 00-1.318-.561l-1.058 1.018a1 1 0 01-.619.277l-3.332.248a1 1 0 01-1.063-1.146l.517-3.454a1 1 0 01.307-.583l5.612-5.234a3 3 0 00.954-2.194v-2.1C15.152.569 14.588 0 13.89 0H6.09v4.081a2 2 0 01-2 2H.001zM4.42 0v3.434a1 1 0 01-1 1H0L4.42 0zm13.218 7.852l-1.222-1.314a1 1 0 01.05-1.411l.75-.702a.63.63 0 01.892.031l1.722 1.853a.635.635 0 01-.03.895l-.746.698a1 1 0 01-1.416-.05zm-.968 2.28l-4.041 3.78a3 3 0 01-1.79.798l-.756.065a1 1 0 01-1.074-1.15l.12-.763a3 3 0 01.914-1.727l4.039-3.778a1 1 0 011.415.05L16.72 8.72a1 1 0 01-.05 1.41z",
  fill: "currentColor",
  fillRule: "nonzero"
});

var SvgMyDocuments = function SvgMyDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MyDocuments.310f1177.svg";
export { ForwardRef as ReactComponent };